<script setup>
import { defineProps } from "vue";

defineProps({
  breadcrumbs: {
    type: Array,
    required: true,
    default: () => [],
  },
});
</script>

<template>
  <nav
    class="p-2 mt-8 mb-3 border-2 border-gray-300 border-dotted shadow-md"
    aria-label="Breadcrumb"
  >
    <ol
      class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0 flex flex-wrap items-center gap-1 overflow-x-auto text-sm text-gray-600"
    >
      <!-- Home link -->
      <li class="shrink-0">
        <a href="#" class="block transition hover:text-gray-700">
          <span class="sr-only">Home</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 md:w-5 md:h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
            />
          </svg>
        </a>
      </li>

      <!-- Breadcrumb Items -->
      <template v-for="(breadcrumb, index) in breadcrumbs" :key="index">
        <li class="shrink-0 rtl:rotate-180">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 md:w-5 md:h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 20.247l6-16.5"
            />
          </svg>
        </li>

        <li class="shrink-0">
          <a
            :href="breadcrumb.href"
            class="block transition hover:text-gray-700 whitespace-nowrap"
          >
            {{ breadcrumb.name }}
          </a>
        </li>
      </template>
    </ol>
  </nav>
</template>
